"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzTextArea = void 0;

var react_1 = __importDefault(require("react"));

var SzTypographie_1 = __importDefault(require("../SzTypographie/SzTypographie"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

require("./SzTextArea.scss");

exports.SzTextArea = function (props) {
  var name = props.name,
      id = props.id,
      label = props.label,
      value = props.value,
      className = props.className,
      variant = props.variant,
      valid = props.valid,
      error = props.error,
      _a = props.rows,
      rows = _a === void 0 ? 5 : _a,
      _b = props.maxLength,
      maxLength = _b === void 0 ? 0 : _b,
      onFocus = props.onFocus,
      leftProps = __rest(props, ["name", "id", "label", "value", "className", "variant", "valid", "error", "rows", "maxLength", "onFocus"]);

  var formGroupClasses = classnames_1.default('sz-form-group w-100', {
    'text-group-outlined': variant && 'outlined' === variant
  });
  var labelClasses = classnames_1.default('sz-form-group__label sz-line-height-normal', {
    'mb-1': !variant,
    'mb-2': variant
  });
  var textareaClasses = classnames_1.default({
    'bg-white text-primary-dark': !variant && value.length > 0,
    'border-danger': error && value.length > 0,
    'sz-form-group__input pt-3': !variant,
    'border-soft': variant
  }, className);

  var RenderHelp = function RenderHelp() {
    if (!maxLength) {
      return null;
    }

    var remaining = maxLength;

    if (value) {
      remaining = maxLength - value.length;
    }

    return react_1.default.createElement(SzTypographie_1.default, {
      variant: "caption",
      align: "left"
    }, remaining, " caract\xE8re(s) restants");
  };

  return react_1.default.createElement("div", {
    className: formGroupClasses
  }, label && react_1.default.createElement("label", {
    className: labelClasses,
    htmlFor: name || id
  }, react_1.default.createElement(SzTypographie_1.default, {
    color: !variant ? 'inactive' : 'dark',
    weight: !variant ? 'bold' : undefined,
    tag: "span",
    size: !variant ? 'S' : 'M'
  }, label)), react_1.default.createElement(react_bootstrap_1.FormControl, __assign({
    name: name,
    as: "textarea",
    id: id,
    value: value
  }, leftProps, {
    className: textareaClasses,
    rows: rows
  })), props.maxLength && react_1.default.createElement(RenderHelp, null));
};

exports.default = exports.SzTextArea;